import { useForm } from "react-hook-form";
import axios, { endpoints } from "src/libs/axios";
import { showAlert } from "src/components/UI/CustomAlert";

type FormValues = {
  firstName: string;
  lastName: string;
  email: string;
  number: string;
  state: string;
  country: string;
  message: string;
};

const getInTouchApi = async (
  payload: {
    firstName: string;
    lastName: string;
    email: string;
    number: string;
    state: string;
    country: string;
    message: string;
    type: string;
  },
  reset: () => void
) => {
  try {
    const response = await axios.post(endpoints?.forms, payload);
    if (response?.status === 201) {
      showAlert(
        "success",
        "We have received your message. We will get back to you soon!"
      );
    }
  } catch (error) {
    showAlert("error", "Something went wrong! Please try again later.");
  } finally {
    reset();
  }
};

const useGetInTouch = () => {
  const {
    register,
    handleSubmit,
    formState: { isValid },
    reset,
  } = useForm<FormValues>({
    mode: "onChange", // so isValid updates as user types
  });
  const onSubmit = (data: FormValues) => {
    const payload = {
      ...data,
      type: "get-in-touch",
    };
    getInTouchApi(payload, reset);
  };

  return {
    onSubmit,
    register,
    handleSubmit,
    isValid,
  };
};

export default useGetInTouch;
